function refreshCartJS() {
  const cartSlide = document.querySelector('cart-slide');
  if (cartSlide) {
    if (cartSlide.refreshCart) cartSlide.refreshCart();
    // Open cart drawer if not active
    if (cartSlide.toggleCart && !cartSlide.classList.contains('active')) {
      cartSlide.toggleCart();
    }
  }
}

function customMiniCartRelatedProductAddToCart(id, quantity, openCart) {
  // Validate variant ID
  if (!id || id === '' || id === 'undefined' || id === 'null') {
    console.error('Invalid variant ID:', id);
    alert('Please select a product variant');
    return;
  }

  // Validate quantity
  if (!quantity || 1 > quantity || isNaN(quantity)) {
    console.error('Invalid quantity:', quantity);
    alert('Please enter a valid quantity');
    return;
  }

  const formData = {
    'items': [{
      'id': String(id), // Ensure ID is a string
      'quantity': parseInt(quantity, 10)
    }]
  };

  fetch(window.routes.cart_add_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (!response.ok) {
        return response.json().then(err => {
            throw new Error(err.description || err.message || 'Failed to add to cart');
        });
    }
    return response.json();
  })
  .then(response => {
    // Refresh cart
    refreshCartJS();
    if (openCart) {
       // logic to open cart is handled in refreshCartJS usually, but we can force it
       const cartSlide = document.querySelector('cart-slide');
       if (cartSlide && !cartSlide.classList.contains('active') && cartSlide.toggleCart) {
           cartSlide.toggleCart();
       }
    }
  })
  .catch(function(error) {
    console.error('Add to cart error:', error);
    alert(error.message || error);
  });
}

function ajaxCartCall() {
    refreshCartJS();
}

function miniCartRefresh(openCart) {
    refreshCartJS();
}
